import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import './i18n/index';
import './index.css';
import './styles/tiptap.css';
import './styles/autofill-fix.css';
import './styles/light-mode-overrides.css';
import { restoreConsent } from './components/CookieConsentBanner';
import { initPostHog } from './lib/posthog';
import { installDeviceIdFetchInterceptor, installDeviceIdAxiosInterceptor, installDeviceIdXhrInterceptor } from './lib/deviceIdFetch';

// Initialise PostHog au plus tôt
initPostHog();

// Doit être installé avant le moindre appel au backend (voir deviceIdFetch.ts)
installDeviceIdFetchInterceptor();
installDeviceIdAxiosInterceptor();
installDeviceIdXhrInterceptor();

function registerGlobalErrorLogging() {
  window.addEventListener('error', (event) => {
    console.error('[GlobalError]', event.error ?? event.message, {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[UnhandledRejection]', event.reason);
  });
}

// Fonction pour nettoyer uniquement le cache des assets statiques
async function clearStaticAssetsCache() {
  try {
    // 1. Supprimer uniquement les caches des assets statiques
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      const staticAssetCaches = cacheNames.filter(name => 
        (name.includes('assets') || name.includes('static')) &&
        !name.includes('firebase') &&
        !name.includes('firestore')
      );
      await Promise.all(staticAssetCaches.map(name => caches.delete(name)));
    }

    // 2. Désinscrire les service workers non essentiels
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        // Ne pas désinscrire les service workers Firebase
        if (!registration.scope.includes('firebase') && 
            !registration.scope.includes('firestore')) {
          await registration.unregister();
        }
      }
    }
  } catch (error) {
    // console.error supprimé
  }
}

// Nettoyer uniquement le cache des assets statiques
clearStaticAssetsCache();
registerGlobalErrorLogging();

// Restaure le consentement GA4 depuis localStorage (si déjà accepté)
restoreConsent();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
